export enum StatusManagePackagesEnum {
	OnTrack = 1,
	AtRisk = 2,
	Delayed = 3,
}
